import React from 'react'

function normalizeHeadingText(value: string) {
  return value.replace(/\s+/g, ' ').trim()
}

function isSelectedNode(node: React.ReactNode): boolean {
  if (!React.isValidElement(node)) {
    return false
  }

  const props = node.props as {
    'aria-current'?: boolean | 'true' | 'false' | string
    'aria-selected'?: boolean | 'true' | 'false'
    className?: string
  }

  if (props['aria-current'] && props['aria-current'] !== 'false') {
    return true
  }

  if (props['aria-selected'] === true || props['aria-selected'] === 'true') {
    return true
  }

  if (typeof props.className === 'string') {
    return /(\b|--)(active|selected|current)(\b|-)/.test(props.className)
  }

  return false
}

export function extractHeadingText(node: React.ReactNode): string {
  if (typeof node === 'string' || typeof node === 'number') {
    return normalizeHeadingText(String(node))
  }

  if (Array.isArray(node)) {
    return normalizeHeadingText(
      node
        .map((child) => extractHeadingText(child))
        .filter(Boolean)
        .join(' ')
    )
  }

  if (!React.isValidElement(node)) {
    return ''
  }

  const props = node.props as {
    children?: React.ReactNode
    'aria-hidden'?: boolean | 'true' | 'false'
    'aria-label'?: string
    title?: string
  }

  if (props['aria-hidden'] === true || props['aria-hidden'] === 'true') {
    return ''
  }

  const childrenText = extractHeadingText(props.children)

  if (childrenText) {
    return childrenText
  }

  if (typeof props['aria-label'] === 'string') {
    return normalizeHeadingText(props['aria-label'])
  }

  if (typeof props.title === 'string') {
    return normalizeHeadingText(props.title)
  }

  return ''
}

export function extractSelectedHeadingText(node: React.ReactNode): string {
  for (const child of React.Children.toArray(node)) {
    if (!React.isValidElement(child) || !isSelectedNode(child)) {
      continue
    }

    const firstNestedChild = React.Children.toArray(
      (child.props as { children?: React.ReactNode }).children
    )[0]

    return extractHeadingText(firstNestedChild)
  }

  return ''
}
